import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, rem } from './../../../styles';
var defaultStyles = process.env.NODE_ENV === "production" ? {
  name: "11ffxfj",
  styles: "display:inline-block;position:relative"
} : {
  name: "svs2a5-defaultStyles",
  styles: "display:inline-block;position:relative;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var sizeStyles = function sizeStyles(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'xs':
      return /*#__PURE__*/css("width:", rem(84), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'sm':
      return /*#__PURE__*/css("width:", rem(128), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'md':
      return /*#__PURE__*/css("width:", rem(164), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css("width:", rem(224), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledVehicleImageContainer = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e13gc3oe0"
} : {
  target: "e13gc3oe0",
  label: "StyledVehicleImageContainer"
})(resetStyles, defaultStyles, sizeStyles);
export default StyledVehicleImageContainer;